import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BOOKS } from "@/lib/books";
import { motion } from "framer-motion";
import { ArrowRight, ShoppingBag } from "lucide-react";

const FADE = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true }, transition: { duration: 0.5 } };

export function FeaturedBooks() {
  return (
    <section className="bg-black border-y border-[#D4AF37]/20 py-20 lg:py-24" data-testid="featured-books-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="text-xs tracking-[0.25em] uppercase text-[#D4AF37] font-semibold mb-4">Publications</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl font-medium tracking-tight text-[#F5F3EF]">Featured Books</h2>
            <p className="mt-4 text-[#A8A29E] max-w-xl">New works from House of Khalil Publishing on our history, our law, and the codes by which we build strong communities.</p>
          </div>
          <Link to="/library" data-testid="home-library-btn">
            <Button variant="outline" className="rounded-none bg-transparent border-[#D4AF37]/50 text-[#F5F3EF] hover:bg-[#D4AF37] hover:text-[#0A0A0A] px-8 py-6">
              Visit The Library <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
        </div>
        <div className="grid sm:grid-cols-3 gap-8">
          {BOOKS.map((b, i) => (
            <motion.div key={b.slug} {...FADE} transition={{ duration: 0.5, delay: i * 0.08 }} className="group flex flex-col" data-testid={`home-book-${b.slug}`}>
              <Link to="/library" className="block overflow-hidden border border-[#D4AF37]/25 bg-[#141414]">
                <img src={b.cover} alt={`${b.title} — front cover`} loading="lazy" className="w-full aspect-[7/10] object-cover group-hover:scale-[1.03] transition-transform duration-500" />
              </Link>
              <h3 className="font-serif-display text-xl text-[#F5F3EF] mt-5 leading-tight">{b.title}</h3>
              <div className="text-xs text-[#A8A29E] mt-1">{b.format} · {b.price}</div>
              <a href={b.url} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-[#D4AF37] hover:text-[#F5F3EF] transition-colors" data-testid={`home-buy-${b.slug}`}>
                <ShoppingBag className="w-4 h-4" /> Purchase
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
